var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { all, delay, put, select, take, takeLatest, } from 'redux-saga/effects';
import axios from 'axios';
import safeSaga from "./utils";
import { GET_SERVICE_PROPERTIES, getServiceProperties, getServicePropertiesSuccess, } from "../actions/serviceProperties";
import { LOAD_USER_ERROR, loadUser, SILENT_RENEW_ERROR, USER_EXPIRED, USER_FOUND, USER_SIGNED_OUT, } from "redux-oidc";
import { userManagerInit } from "../actions/userManager";
import { LOAD_CONFIGURATION, setAxiosReady, setToken } from "../actions/axios";
import { setAsPowerUser, setUserType } from "../actions/user";
import { matchPath } from "react-router";
import { history } from "../store";
import { TokenType } from "../../interfaces/store/reducers/axios";
import { initializeI18n, SET_I18N_READY } from "../actions/i18n";
import { setEditorDisabled } from "../actions/editor";
function getFluxUrl() {
    return select(function (state) { return state.serviceProperties.fluxUrl; });
}
function initializeAppData(_a) {
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, put(setUserType(payload))];
            case 1:
                _b.sent();
                return [4, refreshToken(payload)];
            case 2:
                _b.sent();
                return [4, put(setAxiosReady())];
            case 3:
                _b.sent();
                return [4, saveUserToFlux()];
            case 4:
                _b.sent();
                return [2];
        }
    });
}
function saveUserToFlux() {
    var selectData, fluxUrl, profile, axiosResponse, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, select(function (state) {
                    var fluxUrl = state.serviceProperties.fluxUrl;
                    var profile = state.oidc.user.profile;
                    return { fluxUrl: fluxUrl, profile: profile };
                })];
            case 1:
                selectData = _a.sent();
                if (!selectData) return [3, 4];
                fluxUrl = selectData.fluxUrl, profile = selectData.profile;
                return [4, axios.put(fluxUrl + "/user", profile)];
            case 2:
                axiosResponse = _a.sent();
                if (!axiosResponse) return [3, 4];
                data = axiosResponse.data;
                return [4, put(setAsPowerUser(data.powerUser))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2];
        }
    });
}
function getServicePropertiesHandler(_a) {
    var resp, data, idpConfigs, matchResult, idpConfigId_1, idpConf, userManager;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, axios.get("./serviceProperties.json?cb=" + process.env.REACT_APP_CACHEBUSTER)];
            case 1:
                resp = _b.sent();
                if (!resp) return [3, 6];
                data = resp.data;
                return [4, put(getServicePropertiesSuccess(data))];
            case 2:
                _b.sent();
                idpConfigs = data.idpConfigs;
                matchResult = matchPath(history.location.pathname, '/:idp/');
                idpConfigId_1 = matchResult && matchResult.params.idp;
                idpConf = idpConfigs.find(function (_a) {
                    var id = _a.id;
                    return id === idpConfigId_1;
                });
                if (!idpConf) {
                    idpConf = idpConfigs[0];
                    history.replace("/" + idpConf.id);
                }
                return [4, put(userManagerInit(idpConf))];
            case 3:
                _b.sent();
                return [4, select(function (state) { return state.userManager; })];
            case 4:
                userManager = _b.sent();
                return [4, loadUser(payload, userManager).catch()];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [2];
        }
    });
}
function refreshToken(_a) {
    var access_token = _a.access_token, token_type = _a.token_type;
    var tokenTypeCapitalised = token_type.charAt(0).toUpperCase() + token_type.slice(1);
    axios.defaults.headers.common['Authorization'] = access_token ? (tokenTypeCapitalised + " " + access_token) : null;
}
function redirectToLogin(_a) {
    var userManager;
    var type = _a.type;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                console.log("Redirect to login requested by:", type);
                return [4, select(function (state) { return state.userManager; })];
            case 1:
                userManager = (_b.sent());
                if (userManager) {
                    userManager.signinRedirect({ state: window.location.href.replace(origin, '') }).catch();
                }
                return [2];
        }
    });
}
function userExpiredHandler(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log("User expired error");
                return [4, signInLoop(action)];
            case 1:
                _a.sent();
                return [2];
        }
    });
}
function silentRenewErrorHandler(action) {
    var message;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                message = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.message;
                console.log("Silent renew error: ", message);
                if (!(message === "Network Error")) return [3, 3];
                return [4, put(setEditorDisabled(true))];
            case 1:
                _b.sent();
                return [4, signInLoop(action)];
            case 2:
                _b.sent();
                return [3, 5];
            case 3: return [4, redirectToLogin(action)];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [2];
        }
    });
}
function signInLoop(action) {
    var userManager, _a, message;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, select(function (state) { return state.userManager; })];
            case 1:
                userManager = (_b.sent());
                if (!userManager) return [3, 12];
                console.log("Retrying silent sign in in 1s");
                return [4, delay(1000)];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                _b.trys.push([3, 6, , 12]);
                return [4, userManager.signinSilent().catch()];
            case 4:
                _b.sent();
                return [4, put(setEditorDisabled(false))];
            case 5:
                _b.sent();
                return [3, 12];
            case 6:
                _a = _b.sent();
                message = _a.message;
                console.log("Sign in silent error:", message);
                if (!(message === "Network Error")) return [3, 9];
                return [4, put(setEditorDisabled(true))];
            case 7:
                _b.sent();
                return [4, signInLoop(action)];
            case 8:
                _b.sent();
                return [3, 11];
            case 9: return [4, redirectToLogin({ type: SILENT_RENEW_ERROR })];
            case 10:
                _b.sent();
                _b.label = 11;
            case 11: return [3, 12];
            case 12: return [2];
        }
    });
}
export function getToken(_a) {
    var tokenKey, token, fluxUrl, url;
    var projectId = _a.projectId, jobId = _a.jobId, taskId = _a.taskId, phase = _a.phase, forceTokenRefresh = _a.forceTokenRefresh, _b = _a.tokenType, tokenType = _b === void 0 ? TokenType.TASK : _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                tokenKey = taskId + "_" + phase;
                switch (tokenType) {
                    case TokenType.JOB:
                        tokenKey = jobId + "_" + phase;
                        break;
                    case TokenType.PROJECT:
                        tokenKey = projectId;
                        break;
                    default:
                        break;
                }
                return [4, select(function (_a) {
                        var axios = _a.axios;
                        return axios.tokens[tokenKey];
                    })];
            case 1:
                token = (_c.sent());
                if (!(token && !forceTokenRefresh)) return [3, 2];
                return [2, token];
            case 2: return [4, getFluxUrl()];
            case 3:
                fluxUrl = (_c.sent());
                url = fluxUrl + "/project/" + projectId + "/job/" + jobId + "/task/" + taskId + "/phase/" + phase + "/sign";
                switch (tokenType) {
                    case TokenType.JOB:
                        url = fluxUrl + "/project/" + projectId + "/job/" + jobId + "/phase/" + phase + "/sign";
                        break;
                    case TokenType.PROJECT:
                        url = fluxUrl + "/project/" + projectId + "/sign";
                        break;
                    case TokenType.EXTERNAL:
                        url = fluxUrl + "/editor/project/" + projectId + "/job/" + jobId + "/task/" + taskId + "/phase/" + phase + "/sign";
                        break;
                    default:
                        break;
                }
                return [4, axios.get(url)];
            case 4:
                (token = (_c.sent()).data.token);
                return [4, put(setToken({ token: token, tokenKey: tokenKey, tokenType: tokenType }))];
            case 5:
                _c.sent();
                return [2, token];
        }
    });
}
export function getExternalJobUrl(_a) {
    var fluxUrl, signUrl, responseUrl, signAxiosResponse, _b, token, resourceToken, urlResponse, url;
    var projectId = _a.projectId, jobId = _a.jobId, taskId = _a.taskId, phase = _a.phase, gatewayUrl = _a.gatewayUrl;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, getFluxUrl()];
            case 1:
                fluxUrl = _c.sent();
                signUrl = fluxUrl + "/editor/project/" + projectId + "/job/" + jobId + "/task/" + taskId + "/phase/" + phase + "/sign";
                return [4, axios.get(signUrl)];
            case 2:
                signAxiosResponse = _c.sent();
                if (!signAxiosResponse) return [3, 5];
                _b = signAxiosResponse.data, token = _b.token, resourceToken = _b.resourceToken;
                return [4, put(setToken({ token: token, tokenKey: projectId, tokenType: TokenType.EXTERNAL }))];
            case 3:
                _c.sent();
                return [4, axios.post(gatewayUrl + "/launch", { token: token, resourceToken: resourceToken })];
            case 4:
                urlResponse = _c.sent();
                if (urlResponse) {
                    url = urlResponse.data.url;
                    responseUrl = url;
                }
                _c.label = 5;
            case 5: return [2, responseUrl];
        }
    });
}
function loadConfigurationHandler(_a) {
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, put(initializeI18n())];
            case 1:
                _b.sent();
                return [4, take(SET_I18N_READY)];
            case 2:
                _b.sent();
                return [4, put(getServiceProperties(payload))];
            case 3:
                _b.sent();
                return [2];
        }
    });
}
export default function actionWatcher() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, all([
                    takeLatest(USER_FOUND, safeSaga(initializeAppData)),
                    takeLatest(USER_EXPIRED, safeSaga(userExpiredHandler)),
                    takeLatest(SILENT_RENEW_ERROR, safeSaga(silentRenewErrorHandler)),
                    takeLatest(LOAD_USER_ERROR, safeSaga(redirectToLogin)),
                    takeLatest(USER_SIGNED_OUT, safeSaga(redirectToLogin)),
                    takeLatest(GET_SERVICE_PROPERTIES, safeSaga(getServicePropertiesHandler)),
                    takeLatest(LOAD_CONFIGURATION, safeSaga(loadConfigurationHandler)),
                ])];
            case 1:
                _a.sent();
                return [2];
        }
    });
}
